import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header";
import Footer from "../layout/footer";
import ClientSlider1 from "../element/clientSlider1";
import BlogSlider1 from "../element/blogSlider1";
import { blogContent3, servicesContent4 } from "../element/SliderContent";
import ServicesSlider1 from "../element/servicesSlider1";
import Testimonial12 from "../element/testimonial12";
//import HomeSlider from '../element/homeslider1'
import { Parallax } from "react-parallax";
import CounterSection from "../element/counterSection";
import Team1 from "../element/team1";
import { useMediaQuery } from "react-responsive";
import "../../css/plugins.css";
import "../../css/style.css";
import "../../css/skin/skin-1.css";
import "../../css/templete.min.css";
import ScrollToTop from "../element/scrollToTop";
import Portfolio from "../element/portfolio";
import Header2 from "../layout/header2";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const bg = require("../../images/background/bg2.jpg");
const bgMobile = require("../../images/hero-mobile.png");
const bg2 = require("../../images/background/bg4.jpg");
const bg3 = require("../../images/background/map-bg.png");
const bg4 = require("../../images/home-page.png");
// const bg4 = require("../../images/home-page.png");
const exellence = require("../../images/quote.png");

const bg5 = require("../../images/background/bg5.jpg");

const projects = [
  {
    id: 1,
    name: "cleaning",
    agriculture: true,
    title: "Window Cleaning",
    client: "John Doe",
    location: "Location",
    subTitle: "System",
    imgUrl: require("../../images/portfolio/PROJECT 1 - Window Cleaning.png")
  },
  {
    id: 2,
    name: "agriculture",
    agriculture: true,
    title: "Mining Plant Set Up",
    subTitle: "Mining / Plants",
    client: "John Doe",
    location: "Location",
    imgUrl: require("../../images/portfolio/PROJECT 2.png")
  },
  {
    id: 3,
    name: "cleaning",
    agriculture: true,
    title: "Carpet Cleaning",
    subTitle: "Engineering",
    client: "John Doe",
    location: "Location",
    imgUrl: require("../../images/portfolio/PROJECT 3 - Carpet Cleaning.png")
  }
];

const services = [
  {
    id: "service1",
    title: "Dependable & Trustworthy",
    bgColor: "#0ba350",
    icon: <i className="fas fa-handshake"></i>, // Outlined handshake icon for trustworthiness
    description:
      "Clients trust us for consistent, reliable service with a personal touch."
  },
  {
    id: "service2",
    bgColor: "#ff8000",
    title: "Advanced Techniques & Equipment",
    icon: <i className="fas fa-cogs"></i>, // Outlined gears icon for advanced techniques
    description: "We utilize cutting-edge technology for spotless results."
  },
  {
    id: "service3",
    title: "Flexible Packages",
    bgColor: "#0152c2",
    icon: <i className="fas fa-sliders-h"></i>, // Outlined sliders icon for flexibility
    description:
      "Customizable options to fit your specific requirements and schedule."
  },
  {
    id: "service4",
    title: "Experienced Team",
    bgColor: "#9500c2",
    icon: <i className="fas fa-users"></i>, // Outlined users icon for experienced team
    description:
      "Our trained professionals deliver meticulous cleaning and outstanding service."
  }
];

const specialties = [
  {
    title: "Eco-Conscious Practices",
    image: "path/to/eco_friendly_image.jpg",
    description: "We use sustainable, eco-friendly products to ensure safety."
  },
  {
    title: "Highly Trained Staff",
    image: "path/to/trained_staff_image.jpg",
    description:
      "Our team receives regular training to deliver efficient, detail-oriented cleaning across various environments."
  },
  {
    title: "Tailored Services",
    image: "path/to/tailored_services_image.jpg",
    description:
      "Flexible, customizable solutions for each client’s unique needs and schedule."
  },
  {
    title: "Commitment to Excellence",
    image: "path/to/excellence_image.jpg",
    description:
      "Every space we clean is spotless, fresh, and inviting, with no corner overlooked."
  }
];

const industries = [
  {
    title: "Office & Commercial",
    description:
      "Cleanliness is essential to professionalism and productivity in commercial spaces. We provide comprehensive office cleaning, covering workstations to high-traffic common areas. Our services include regular cleaning, carpet and upholstery care, and restroom sanitization, all scheduled for minimal disruption to your business operations. A polished, professional atmosphere awaits every day."
  },
  {
    title: "Healthcare",
    description:
      "In healthcare, cleanliness is critical. Our specialized healthcare cleaning meets stringent sanitation standards in hospitals, clinics, and aged care facilities. With a focus on infection control, we use approved products to ensure a safe environment, covering high-touch areas, patient rooms, exam spaces, and operating rooms."
  },
  {
    title: "Industrial & Manufacturing",
    description:
      "For industrial sites, we offer tailored cleaning strategies to accommodate machinery, production residues, and compliance regulations. Services range from equipment cleaning to floor maintenance and waste management, keeping your facility safe, efficient, and compliant with health standards."
  },
  {
    title: "Education",
    description:
      "A clean school or university supports the well-being of students and staff alike. Our educational cleaning services cover classrooms, libraries, labs, and shared spaces to reduce germs and provide a welcoming environment for learning. Tailored to the high-traffic nature of schools, our solutions offer consistent cleanliness and safety."
  },
  {
    title: "Hospitality & Accommodation",
    description:
      "In hospitality, first impressions matter. We serve hotels, resorts, and other accommodations, maintaining guest rooms, lobbies, dining areas, and public spaces. With Kangaroo Shine, guests experience a spotless, welcoming atmosphere that enhances their stay."
  },
  {
    title: "Retail Stores & Shopping Centres",
    description:
      "A clean retail environment enhances the shopping experience and reflects positively on your brand. Our services cover stores, malls, and shopping centers, focusing on floors, displays, fitting rooms, and restrooms to create an inviting atmosphere during peak shopping hours."
  }
];

const Index = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const history = useHistory();
  const sendtoContact = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    history.push("/contact");
  };
  return (
    <div className="skin-1">
      <Header />

      <Parallax bgImage={isMobile ? bgMobile : bg4} strength={200}>
        <div id="home" className="hero-section pt-50 home-bnr1">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-9 col-md-12">
                <div className="hero-content">
                  <h2 className="title">
                    Bringing Sparkle to Queensland's <br /> Commercial &
                    Industrial Spaces
                  </h2>
                  <div className="description">
                    Trusted Cleaning Solutions for a Cleaner, Safer Environment
                  </div>
                  <button
                    onClick={() => sendtoContact()}
                    class="btn custom-quote-btn white-btn white-btn-mobile"
                  >
                    Get a quote
                  </button>
                  {/* <div className="buttons">
                    <Link to={"#"}>Read More</Link>
                    <Link to={"#"}>About Us</Link>
                  </div> */}
                </div>
              </div>
              {/* <div className="col-lg-6 col-md-12">
                <img
                  src={require("../../images/main-slider/slide7.png")}
                  alt=""
                />
              </div> */}
            </div>
          </div>
        </div>
      </Parallax>

      <div className="page-content bg-white">
        <div className="content-block">
          <div id="about" className="section-full content-inner bg-white">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-12 m-b30">
                  <div className="our-story">
                    <span>About Us</span>
                    <h2 className="title">The Shine Behind the Clean</h2>

                    <p>
                      Kangaroo Shine Property Services is a family-owned
                      cleaning company in Gold Coast. At Kangaroo Shine Property
                      Services, we’re committed to creating immaculate, healthy
                      spaces across Australia. From residential properties to
                      commercial complexes and industrial sites, our cleaning
                      professionals deliver results you can count on. Using
                      advanced techniques and eco-friendly solutions, we ensure
                      every surface shines, enhancing the safety and appeal of
                      your environment. Discover a higher standard of clean –
                      tailored to your needs by Kangaroo Shine.
                    </p>
                    <p>
                      Our fully insured cleaners are professionals with a
                      minimum of five years of expertise in the field. The team
                      is passionate about providing the best cleaning services
                      for customers to create a hygienic and favorable
                      environment that meets the highest standards.
                    </p>
                    <p>
                      Whether it’s regular maintenance, a deep clean, or
                      specialized service, our experience, attention to detail,
                      and exceptional customer care make all the difference.
                    </p>

                    <button
                      onClick={() => sendtoContact()}
                      class="btn custom-quote-btn"
                    >
                      Get a quote
                    </button>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 m-b30 our-story-thum">
                  <img
                    src={require("../../images/abtus.png")}
                    className="radius-sm"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            id="services"
            className="section-full bg-gray content-inner about-carousel-ser"
          >
            <div className="container">
              <div className="section-head text-center">
                <span className="title-box">Our Services</span>
                <h2 className="title-new">Cleaning, Redefined</h2>

                <p>
                  From regular upkeep to one-off deep cleans, our comprehensive
                  range of services is designed to keep your business spotless,
                  hygienic, and safe. Whether it’s routine maintenance or
                  specialized cleaning for high-traffic areas, we’re here to
                  ensure your facility operates at its best.
                </p>
              </div>

              <div className=" row col-md-12">
                {servicesContent4.map((item, serviceIndex) => {
                  return <NewServiceCard item={item} />;
                })}
              </div>

              {/* <ServicesSlider1 slidesToShow={3} data={servicesContent4} /> */}
            </div>
          </div>

          <div className="section-full bg-gray content-inner">
            <div className="container">
              <div className="section-head text-center">
                <span className="title-box">Choose Us</span>
                <h2 className="title-new">Shining Above the Rest</h2>
                <p className="new-des">
                  At Kangaroo Shine, we don’t just clean—we create environments
                  that inspire confidence. With expert technicians, eco-friendly
                  practices, and an unwavering commitment to quality, we go
                  above and beyond to deliver outstanding results for every
                  client. Our customer-first approach ensures that your
                  satisfaction is always our top priority.
                </p>
              </div>
              <div className="section-content row">
                {services.map((service, index) => {
                  return (
                    <ServiceCard
                      icon={service.icon}
                      bgColor={service.bgColor}
                      title={service.title}
                      description={service.description}
                      index={index}
                    />
                  );
                })}
              </div>
            </div>
          </div>

          <div
            className="section-full bg-img-fix content-inner-2 contact-action style2"
            style={{ backgroundImage: "url(" + exellence + ")" }}
          >
            <div className="container">
              <div className="row relative">
                <div
                  className="col-md-12 col-lg-8 wow fadeInLeft"
                  data-wow-duration="2s"
                  data-wow-delay="0.2s"
                >
                  <div className="contact-no-area">
                    <h2 className="title">
                      Excellence in Cleanliness and <br /> Service
                    </h2>
                    <p>
                      Call our friendly team to discuss your next cleaning job
                    </p>
                    <div className="contact-no">
                      <div className="contact-left">
                        <button
                          onClick={() => sendtoContact()}
                          class="btn custom-quote-btn"
                        >
                          Get a quote
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-12 col-lg-4 contact-img-bx wow fadeInRight relative"
                  data-wow-duration="2s"
                  data-wow-delay="0.2s"
                >
                  <img src={require("../../images/pic1.png")} alt="" />
                </div>
              </div>
            </div>
          </div>

          {/* <CounterSection backgroundImage={bg2} /> */}

          {/* <div className="section-full bg-gray content-inner">
            <div className="container">
              <div className="section-head text-center ">
                <h2 className="title"> Meet The Team</h2>
                <p>
                  There are many variations of passages of Lorem Ipsum
                  typesetting industry has been the industry's standard dummy
                  text ever since the been when an unknown printer.
                </p>
              </div>
              <Team1 />
            </div>
          </div> */}

          <div
            className="section-full overlay-black-middle bg-secondry content-inner-2 wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.2s"
            // style={{ backgroundImage: "url(" + bg3 + ")" }}
          >
            <div className="container">
              <div className="section-head text-white text-center">
                <span className="title-box">Our Specialty</span>
                <h2 className="title-new">Cleaning with Precision</h2>
                <p>
                  We specialize in cleaning high-demand commercial and
                  industrial spaces, where precision and efficiency are
                  essential. Whether it's maintaining large facilities, deep
                  cleaning after major projects, or managing complex workspaces,
                  we deliver exceptional results with care and attention to
                  detail, making sure your space is not only clean but also safe
                  and functional.
                </p>
              </div>

              <div className="section-content specialties p-b0">
                <div className="row ">
                  {specialties.map((specialty, index) => {
                    return (
                      <div
                        className="col-lg-6 col-md-6 col-sm-6 mb-4"
                        key={index}
                      >
                        <div
                          className="border rounded-sm specialty shadow-lg h-100 p-4"
                          style={{
                            // backgroundColor: "rgba(58, 74, 92, 0.5)",
                            borderRadius: "10px"
                          }} // Adding small radius
                        >
                          <div className="mb-3 specialty-icon">
                            {/* Adjusted icons for each specialty */}
                            {index === 0 && (
                              <i className="fas fa-leaf text-white"></i>
                            )}
                            {index === 1 && (
                              <i className="fas fa-user-graduate text-white"></i>
                            )}
                            {index === 2 && (
                              <i className="fas fa-cogs text-white "></i>
                            )}
                            {index === 3 && (
                              <i className="fas fa-thumbs-up text-white "></i>
                            )}
                          </div>
                          <div className=" specialty-conent">
                            <h5 className="card-title text-xl  text-secondry font-weight-bold ">
                              {specialty.title}
                            </h5>
                            <p className="card-text text-white text-base">
                              {specialty.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="flex-center">
                <button
                  onClick={() => sendtoContact()}
                  class="btn custom-quote-btn"
                >
                  Get a quote
                </button>
              </div>
            </div>
          </div>

          {/* <div
            id="blogs"
            className="section-full content-inner bg-gray wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.4s"
          >
            <div className="container">
              <div className="section-head text-center">
                <h2 className="title">Latest blog post</h2>
                <p>
                  Explore our blog for expert tips, industry trends, and
                  cleaning advice. Regular updates help you maintain a cleaner,
                  healthier space.
                </p>
              </div>

              <BlogSlider1
                data={blogContent3}
                blogPostCls="post-style-1"
                imgEffect="rotate"
                noDes
              />
            </div>
          </div> */}
          {/* <div
            id="latest"
            className="section-full content-inner bg-gray wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.4s"
          >
            <div className="container">
              <div className="section-head text-center">

              <span className="title-box">Latest Projects Completed</span>
                <p>
                  Kangaroo Shine Property Services stands out for our commitment
                  to quality and customer satisfaction. Here’s what makes us a
                  preferred choice in the cleaning industry:
                </p>
              </div>
              <div className=" row col-md-12">
                {projects.map((item, temIndex) => {
                  return(
                    <ProjectCard item={item} />
                  )
                })}
                </div>
            </div>
          </div> */}

          {/* <div
           id="testimonials"
            className="section-full  content-inner-2 wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.2s"
            // style={{ backgroundImage: "url(" + bg3 + ")" }}
          >
            <div className="container">
              <div className="section-head text-center">
                <span className="title-box">Testimonial</span>
                <h2 className="title-new">What People Are Saying</h2>
                <p className="new-des">
                  Our clients’ satisfaction is our top priority, and we’re
                  honored to share their experiences with you. See why so many
                  trust Kangaroo Shine Property Services to maintain their
                  spaces to the highest standards.
                </p>
              </div>
              <div className="section-content">
                <Testimonial12 />
              </div>
            </div>
          </div> */}

          <div id="industries" className="section-full bg-gray content-inner">
            <div className="container">
              <div className="section-head text-center">
                <span className="title-box">Industries</span>
                <h2 className="title-new">
                  Clean Solutions for Every Industry
                </h2>
                <p className="new-des">
                  Kangaroo Shine proudly serves a wide range of industries, from
                  healthcare and manufacturing to retail and hospitality. No
                  matter the sector, we offer specialized cleaning solutions
                  designed to meet the unique needs of your business, ensuring a
                  safe, clean, and productive environment for employees
                  and clients alike.
                </p>
              </div>
              <div className="section-content insdustry-section row">
                {industries.map((industry, index) => {
                  return (
                    <div className=" col-md-6 col-sm-12 mb30 ">
                      <div className="industry-card">
                        <div className=" industry-icon">
                          <i className="fas fa-cogs"></i>
                        </div>
                        <div className="industry-card-content">
                          <h4>{industry.title}</h4>
                          <p>{industry.description}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* <div
            className="section-full content-inner bg-gray wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.4s"
          >
            <div className="container">
              <div className="section-head text-center">
                <h2 className="title">
                  Industries We Serve <br />
                  <span className="text-primary">
                    Tailored Solutions for Every Sector.
                  </span>
                </h2>
                <p>
                  Kangaroo Shine Property Services specializes in custom
                  cleaning for a wide range of industries. From ensuring sterile
                  healthcare facilities to maintaining polished commercial
                  spaces, we adapt techniques and schedules to your unique
                  needs. Here’s an overview of our expertise across industries:
                </p>
              </div>

              <div className="section-content p-b0">
                <div className="row">
                  {industries.map((industry, index) => {
                    return (
                      <div className="col-md-12 col-lg-12">
                        <div className="blog-post blog-md shadow  clearfix border-1 br-col-b1 radius-sm">
                          <div className="dlab-post-media dlab-img-effect zoom-slow">
                            <Link to={"./blog-single"}>
                              <img
                                src={require("../../images/blog/grid/pic1.jpg")}
                                alt=""
                              />
                            </Link>
                          </div>
                          <div className="dlab-post-info">
                            <div className="dlab-post-title">
                              <h4 className="post-title">
                                <Link to={"./blog-single"}>
                                  {industry.title}
                                </Link>
                              </h4>
                            </div>
                            <div className="dlab-post-text">
                              <p className="p-r15">{industry.description}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div> */}

          {/* <div id="industries" className="section-full box-about-list">
            <div className="row spno">
              <div className="col-lg-6 col-md-12">
                <img
                  src={require("../../images/about/pic3.jpg")}
                  alt=""
                  className="img-cover"
                />
              </div>
              <div className="col-lg-6 col-md-12 bg-primary">
                <div className="max-w900 m-auto p-t50 p-lr20">
                  <div className="text-white">
                    <h2>
                      Industries We Serve
                      <br />
                      Tailored Solutions for Every Sector.
                    </h2>
                  </div>
                  {industries.slice(0, 3).map((industry, index) => {
                    return (
                      <div className="icon-bx-wraper m-b30 left">
                        <div className="icon-md">
                          <Link to={"/#"} className="icon-cell text-white">
                            <i className="flaticon-factory"></i>
                          </Link>
                        </div>
                        <div className="icon-content">
                          <h4 className="dlab-tilte">{industry.title}</h4>
                          <p>{industry.description}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="section-full box-about-list">
            <div className="row spno">
              <div className="col-lg-6 d-none d-lg-block col-md-12">
                <img
                  src={require("../../images/about/pic3.jpg")}
                  alt=""
                  className="img-cover"
                />
              </div>
              <div className="col-lg-6 col-md-12 bg-primary">
                <div className="max-w900 m-auto p-lr20">
                  {industries.slice(3, 6).map((industry, index) => {
                    return (
                      <div className="icon-bx-wraper m-b30 left">
                        <div className="icon-md">
                          <Link to={"/#"} className="icon-cell text-white">
                            <i className="flaticon-factory"></i>
                          </Link>
                        </div>
                        <div className="icon-content">
                          <div className="icon-content">
                            <h4 className="dlab-tilte">{industry.title}</h4>
                            <p>{industry.description}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="section-full box-about-list">
            <div className="row spno">
              <div className="col-lg-6 d-none d-lg-block col-md-12">
                <img
                  src={require("../../images/about/pic3.jpg")}
                  alt=""
                  className="img-cover"
                />
              </div>
              <div className="col-lg-6 col-md-12 bg-primary">
                <div className="max-w900 m-auto p-lr20">
                  {industries.slice(4, 6).map((industry, index) => {
                    return (
                      <div className="icon-bx-wraper m-b30 left" key={index}>
                        <div className="icon-md">
                          <Link to={"/#"} className="icon-cell text-white">
                            <i className="flaticon-factory"></i>
                          </Link>
                        </div>
                        <div className="icon-content">
                          <h4 className="dlab-tilte">{industry.title}</h4>
                          <p>{industry.description}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div> */}

          {/* <div
            className="section-full dlab-we-find bg-img-fix p-t20 p-b20 bg-white wow fadeIn"
            data-wow-duration="2s"
            data-wow-delay="0.6s"
          >
            <div className="container">
              <div className="section-content">
                <ClientSlider1 hideBorder />
              </div>
            </div>
          </div> */}
          {/* <div
           id="contact"
            className="section-full content-inner contact-page-9 overlay-black-dark"
            style={{ background: "url(" + bg5 + ") 30% 100%" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-12 text-white">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 m-b30">
                      <div className="icon-bx-wraper bx-style-1 p-a20 radius-sm">
                        <div className="icon-content">
                          <h5 className="dlab-tilte">
                            <span className="icon-sm text-primary">
                              <i className="ti-location-pin"></i>
                            </span>
                            Company Address
                          </h5>
                          <p>6308 31 Bourton road Merrimac 4226</p>
                          <h5 className="dlab-tilte">
                            <span className="icon-sm text-primary">
                              <i className="ti-location-pin"></i>
                            </span>
                            Service Areas
                          </h5>
                          <p>Proudly serving Gold Coast QLD </p>
                          <h6 className="m-b15 font-weight-400">
                            <i className="ti-alarm-clock"></i> Business Hours
                          </h6>
                          <p className="m-b0">
                            Monday – Friday: 8:00 am – 6:00 pm
                          </p>
                          <p className="m-b0">Saturday: 9:00 am – 5:00 pm</p>
                          <p>Sunday - Close</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-6 m-b30">
                      <div className="icon-bx-wraper bx-style-1 p-a20 radius-sm">
                        <div className="icon-content">
                          <h5 className="dlab-tilte">
                            <span className="icon-sm text-primary">
                              <i className="ti-email"></i>
                            </span>
                            E-mail
                          </h5>
                          <p className="m-b0">info@kangarooshine.com.au</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-6 m-b30">
                      <div className="icon-bx-wraper bx-style-1 p-a20 radius-sm">
                        <div className="icon-content">
                          <h5 className="dlab-tilte">
                            <span className="icon-sm text-primary">
                              <i className="ti-mobile"></i>
                            </span>
                            Phone Numbers
                          </h5>
                          <p className="m-b0">0424 888 804</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-8 col-md-12 m-b30">
                  <form
                    className="inquiry-form wow box-shadow bg-white fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <h3 className="title-box font-weight-300 m-t0 m-b10">
                      Get in Touch with Kangaroo Shine Property Services
                      <span className="bg-primary"></span>
                    </h3>
                    <p>
                      Whether you’re looking for regular cleaning, a one-time
                      deep clean, or specialized services, Kangaroo Shine
                      Property Services is here to help. We’d love to discuss
                      your needs and create a custom cleaning plan that keeps
                      your space spotless and inviting.
                    </p>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="form-group">
                          <div className="input-group">
                            <span className="input-group-addon">
                              <i className="ti-user text-primary"></i>
                            </span>
                            <input
                              name="dzName"
                              type="text"
                              required
                              className="form-control"
                              placeholder="First Name"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="form-group">
                          <div className="input-group">
                            <span className="input-group-addon">
                              <i className="ti-mobile text-primary"></i>
                            </span>
                            <input
                              name="dzOther[Phone]"
                              type="text"
                              required
                              className="form-control"
                              placeholder="Phone"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <span className="input-group-addon">
                              <i className="ti-email text-primary"></i>
                            </span>
                            <input
                              name="dzEmail"
                              type="email"
                              className="form-control"
                              required
                              placeholder="Your Email Id"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="form-group">
                          <div className="input-group">
                            <span className="input-group-addon">
                              <i className="ti-check-box text-primary"></i>
                            </span>
                            <select className="input-select form-control">
                              <option>Select Industry</option>
                              <option>Oil/Gas Plant</option>
                              <option>Steel Plant</option>
                              <option>Factory</option>
                              <option>Construct</option>
                              <option>Solar Plant</option>
                              <option>Food Industry</option>
                              <option>Agriculture</option>
                              <option>Ship Industry</option>
                              <option>Leather Industry</option>
                              <option>Nuclear Plant</option>
                              <option>Beer Factory</option>
                              <option>Mining Industry</option>
                              <option>Car Industry</option>
                              <option>Plastic Industry</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="form-group">
                          <div className="input-group">
                            <span className="input-group-addon">
                              <i className="ti-file text-primary"></i>
                            </span>
                            <input
                              name="dzOther[Subject]"
                              type="text"
                              required
                              className="form-control"
                              placeholder="Upload File"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <span className="input-group-addon">
                              <i className="ti-agenda text-primary"></i>
                            </span>
                            <textarea
                              name="dzMessage"
                              rows="4"
                              className="form-control"
                              required
                              placeholder="Tell us about your project or idea"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <button
                          name="submit"
                          type="submit"
                          value="Submit"
                          className="site-button button-md"
                        >
                          {" "}
                          <span>Get A Free Quote!</span>{" "}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <Footer hideContactInfo displayNewsLetter />
      <ScrollToTop className="icon-up" />
    </div>
  );
};

const ServiceCard = ({ icon, title, description, bgColor, index }) => {
  return (
    <div
      className="col-md-3 col-lg-3 col-sm-12 service-box style3 chooce-card wow fadeInUp"
      data-wow-duration="2s"
      data-wow-delay="0.2s"
    >
      <div
        className="icon-bx-wraper box-flex"
        // data-name={(index + 1).toString().padStart(2, "0")}
      >
        <div
          className="icon-lg choose-icon"
          style={{ backgroundColor: `${bgColor}` }}
        >
          <Link to="#" className="icon-cell">
            {icon}
          </Link>
        </div>
        <div className="icon-content text-center">
          <h2 className="dlab-tilte">{title}</h2>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

const NewServiceCard = ({ item }) => {
  return (
    <div className="col-md-4 new-service-card mb-20">
      <div className="dlab-box service-media-bx  service-boxq">
        <div className="dlab-media dlab-img-effect zoom service-image">
          <Link
            onClick={() => {
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "auto"
              });
            }}
            to={item.link}
          >
            <img src={item.image} alt="" />
          </Link>
        </div>
        <div className="dlab-info new-service-padding text-center">
          <h2 className="dlab-title">
            <Link
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "auto"
                });
              }}
              to={item.link}
              className="service-title"
            >
              {item.serviceName}
            </Link>
          </h2>
          <p>{item.description}</p>
          <Link
            onClick={() => {
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "auto"
              });
            }}
            to={item.link}
            className="site-button btnhover15"
          >
            Read More
          </Link>
        </div>
      </div>
    </div>
  );
};

const ProjectCard = ({ item }) => {
  return (
    <div className="col-md-4 new-service-card project-card mb-20">
      <div className="dlab-box service-media-bx  service-boxq">
        <div className="dlab-media dlab-img-effect zoom service-image">
          <Link
            onClick={() => {
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "auto"
              });
            }}
            to={item.link}
          >
            <img src={item.imgUrl} alt="" />
          </Link>
        </div>
        <div className="dlab-info new-service-padding">
          <h2 className="dlab-title">
            <Link
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "auto"
                });
              }}
              to={item.link}
              className="service-title"
              style={{ color: "#bfa992" }}
            >
              {item.title}
            </Link>
          </h2>
          <p className="project-p">{item.client}</p>
          <p className="project-location">{item.location}</p>
          <Link
            onClick={() => {
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "auto"
              });
            }}
            to={item.link}
            className="site-button btnhover15"
          >
            Read More
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Index;
